<nz-page-header nzBackIcon (nzBack)="goBack()" [nzTitle]="pkg()?.name || ('servicePackages.view.title' | translate)">
  <nz-page-header-tags>
    @if (pkg()?.isActive) {
      <nz-tag nzColor="green">{{ 'servicePackages.active' | translate }}</nz-tag>
    } @else {
      <nz-tag nzColor="default">{{ 'servicePackages.inactive' | translate }}</nz-tag>
    }
  </nz-page-header-tags>
  <nz-page-header-extra>
    <nz-space>
      @if (pkg()?.isActive) {
        <button *nzSpaceItem nz-button nzType="primary" (click)="sellPackage()">
          <span nz-icon nzType="shopping-cart" nzTheme="outline"></span>
          {{ 'servicePackages.buttons.sell' | translate }}
        </button>
      }
      <button *nzSpaceItem nz-button nzType="default" (click)="editPackage()">
        <span nz-icon nzType="edit" nzTheme="outline"></span>
        {{ 'buttons.edit' | translate }}
      </button>
      <button
        *nzSpaceItem
        nz-button
        nzDanger
        nz-popconfirm
        [nzPopconfirmTitle]="'servicePackages.confirm.delete' | translate"
        (nzOnConfirm)="deletePackage()"
      >
        <span nz-icon nzType="delete" nzTheme="outline"></span>
        {{ 'buttons.delete' | translate }}
      </button>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>

<nz-spin [nzSpinning]="loading()">
  @if (pkg(); as pkg) {
    <!-- Package Details -->
    <nz-card [nzTitle]="'servicePackages.view.details' | translate" class="mb-4">
      <nz-descriptions nzBordered [nzColumn]="2">
        <nz-descriptions-item [nzTitle]="'servicePackages.form.name' | translate">
          {{ pkg.name }}
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'servicePackages.form.price' | translate">
          {{ pkg.price | number:'1.2-2' }} ₾
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'servicePackages.form.validityDays' | translate">
          {{ pkg.validityDays }} {{ 'servicePackages.days' | translate }}
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'servicePackages.columns.services' | translate">
          {{ getTotalItemsCount(pkg) }}
        </nz-descriptions-item>
        @if (pkg.description) {
          <nz-descriptions-item [nzTitle]="'servicePackages.form.description' | translate" [nzSpan]="2">
            {{ pkg.description }}
          </nz-descriptions-item>
        }
      </nz-descriptions>
    </nz-card>

    <!-- Included Services -->
    <nz-card [nzTitle]="'servicePackages.view.includedServices' | translate" class="mb-4">
      <nz-table #itemsTable [nzData]="pkg.items" [nzFrontPagination]="false" [nzShowPagination]="false" nzSize="small">
        <thead>
          <tr>
            <th>{{ 'servicePackages.form.serviceName' | translate }}</th>
            <th>{{ 'servicePackages.form.quantity' | translate }}</th>
            <th>{{ 'servicePackages.form.originalPrice' | translate }}</th>
            <th>{{ 'servicePackages.form.discountedPrice' | translate }}</th>
            <th>{{ 'servicePackages.view.subtotal' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of pkg.items; track item.id) {
            <tr>
              <td>{{ item.serviceName || item.serviceId }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.originalPrice | number:'1.2-2' }} ₾</td>
              <td>{{ item.discountedPrice | number:'1.2-2' }} ₾</td>
              <td class="font-medium">{{ item.quantity * item.discountedPrice | number:'1.2-2' }} ₾</td>
            </tr>
          }
        </tbody>
      </nz-table>
    </nz-card>

    <!-- Recent Purchases -->
    <nz-card [nzTitle]="'servicePackages.view.recentPurchases' | translate">
      <nz-table #purchasesTable [nzData]="purchases()" [nzFrontPagination]="false" [nzShowPagination]="false" nzSize="small">
        <thead>
          <tr>
            <th>{{ 'servicePackages.purchases.customer' | translate }}</th>
            <th>{{ 'servicePackages.purchases.status' | translate }}</th>
            <th>{{ 'servicePackages.purchases.price' | translate }}</th>
            <th>{{ 'servicePackages.purchases.usage' | translate }}</th>
            <th>{{ 'servicePackages.purchases.validUntil' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (purchase of purchases(); track purchase.id) {
            <tr>
              <td>{{ purchase.customer?.name || '—' }}</td>
              <td>
                <nz-tag [nzColor]="getStatusColor(purchase.status)">
                  {{ 'servicePackages.status.' + purchase.status | translate }}
                </nz-tag>
              </td>
              <td>{{ purchase.purchasePrice | number:'1.2-2' }} ₾</td>
              <td>{{ purchase.usedServicesCount }}/{{ purchase.totalServicesCount }}</td>
              <td>{{ purchase.validUntil | date:'dd/MM/yyyy' }}</td>
            </tr>
          }
          @if (purchases().length === 0) {
            <tr>
              <td colspan="5" class="text-center text-gray-400">
                {{ 'servicePackages.purchases.empty' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </nz-card>
  }
</nz-spin>
